module.exports = __webpack_public_path__ + "static/img/leftTopLogo.8dbdce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/leftTopLogo.png
// module id = mMzC
// module chunks = 44